module.exports = __webpack_public_path__ + "img/eye-cross-active.94c836b8.svg";